module.exports = __webpack_public_path__ + "img/reserve-cincinnatus-2.9ccf8e61.png";